"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeAlertStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeAlertStyles = function makeAlertStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiAlert: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          borderRadius: primitives.borderRadii.none,
          color: tokens.colors["ink-on-background"].rgb
        }, tokens.typography["short-copy-small"]), {}, {
          '[class*="MuiAlert-icon"] svg': {
            height: primitives.spacings["6"],
            width: primitives.spacings["6"]
          },
          padding: "2px ".concat(primitives.spacings["4"]),
          '& [class*="MuiAlert-message"]': {
            lineHeight: primitives.lineHeights.compact,
            padding: primitives.spacings["0"],
            margin: "10px 0",
            paddingTop: "1px",
            overflow: "visible"
          }
        }),
        standard: {
          '& [class*="MuiAlert-action"] > button > svg': {
            color: tokens.colors["ink-on-background"].rgb
          },
          '& [class*="MuiAlert-action"] > button': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fade-gradient-transparent"].rgb
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover": _objectSpread({
              backgroundColor: tokens.colors["hover-fill-subtle"].rgb
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: tokens.colors["pressed-fill-subtle"].rgb
            }, tokens.transitions["state-activate"])
          })
        },
        standardInfo: {
          backgroundColor: tokens.colors["fill-engage-slight"].rgb,
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.iris, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"].rgb)
            }
          }
        },
        standardError: {
          backgroundColor: tokens.colors["fill-alert-slight"].rgb,
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.clay, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"].rgb)
            }
          }
        },
        standardSuccess: {
          backgroundColor: tokens.colors["fill-success-slight"].rgb,
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.plant, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"].rgb)
            }
          }
        },
        standardWarning: {
          backgroundColor: tokens.colors["fill-warning-slight"].rgb,
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.gold, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"].rgb)
            }
          }
        },
        outlined: {
          padding: "1px ".concat(primitives.spacings["4"]),
          '& [class*="MuiAlert-action"] > button > svg': {
            color: tokens.colors["ink-on-background"].rgb
          },
          '& [class*="MuiAlert-action"] > button': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fade-gradient-transparent"].rgb
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover": _objectSpread({
              backgroundColor: tokens.colors["hover-fill-subtle"].rgb
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: tokens.colors["pressed-fill-subtle"].rgb
            }, tokens.transitions["state-activate"])
          })
        },
        outlinedInfo: {
          border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["fill-engage"].rgb),
          backgroundColor: tokens.colors["fill-engage-slight"].rgb,
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.iris, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"].rgb)
            }
          }
        },
        outlinedError: {
          border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["fill-alert"].rgb),
          backgroundColor: tokens.colors["fill-alert-slight"].rgb,
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.clay, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"].rgb)
            }
          }
        },
        outlinedSuccess: {
          border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["fill-success"].rgb),
          backgroundColor: tokens.colors["fill-success-slight"].rgb,
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.plant, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"].rgb)
            }
          }
        },
        outlinedWarning: {
          border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["fill-warning"].rgb),
          backgroundColor: tokens.colors["fill-warning-slight"].rgb,
          '& [class*="MuiAlert-action"] > button': {
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.gold, ", 0px 0px 0px 3px ").concat(tokens.colors["fill-primary"].rgb)
            }
          }
        },
        filled: {
          '[class*="MuiAlert-icon"] svg': {
            color: "inherit"
          }
        },
        filledInfo: {
          backgroundColor: tokens.colors["fill-engage"].rgb,
          color: tokens.colors["ink-on-fill-engage"].rgb,
          '& [class*="MuiAlert-action"] > button > svg': {
            color: tokens.colors["ink-on-fill-engage"].rgb
          },
          '& [class*="MuiAlert-action"] > button': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fade-gradient-transparent"].rgb
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover": _objectSpread({
              backgroundColor: "rgba(255, 255, 255, 0.12)"
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: "rgba(255, 255, 255, 0.16)"
            }, tokens.transitions["state-activate"]),
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.iris, ", 0px 0px 0px 3px ").concat(primitives.colors.primary.white)
            }
          })
        },
        filledError: {
          backgroundColor: tokens.colors["fill-alert"].rgb,
          color: tokens.colors["ink-on-fill-alert"].rgb,
          '& [class*="MuiAlert-action"] > button > svg': {
            color: tokens.colors["ink-on-fill-alert"].rgb
          },
          '& [class*="MuiAlert-action"] > button': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fade-gradient-transparent"].rgb
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover": _objectSpread({
              backgroundColor: "rgba(255, 255, 255, 0.12)"
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: "rgba(255, 255, 255, 0.16)"
            }, tokens.transitions["state-activate"]),
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.clay, ", 0px 0px 0px 3px ").concat(primitives.colors.primary.white)
            }
          })
        },
        filledSuccess: {
          backgroundColor: tokens.colors["fill-success"].rgb,
          color: tokens.colors["ink-on-fill-success"].rgb,
          '& [class*="MuiAlert-action"] > button > svg': {
            color: tokens.colors["ink-on-fill-success"].rgb
          },
          '& [class*="MuiAlert-action"] > button': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fade-gradient-transparent"].rgb
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover": _objectSpread({
              backgroundColor: "rgba(0, 0, 0, 0.03)"
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: "rgba(0, 0, 0, 0.15)"
            }, tokens.transitions["state-activate"]),
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.plant, ", 0px 0px 0px 3px ").concat(primitives.colors.primary.black)
            }
          })
        },
        filledWarning: {
          backgroundColor: tokens.colors["fill-warning"].rgb,
          color: tokens.colors["ink-on-fill-warning"].rgb,
          '& [class*="MuiAlert-action"] > button > svg': {
            color: tokens.colors["ink-on-fill-warning"].rgb
          },
          '& [class*="MuiAlert-action"] > button': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fade-gradient-transparent"].rgb
          }, tokens.transitions["state-blur"]), {}, {
            "&:hover": _objectSpread({
              backgroundColor: "rgba(0, 0, 0, 0.03)"
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: "rgba(0, 0, 0, 0.15)"
            }, tokens.transitions["state-activate"]),
            "&:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.gold, ", 0px 0px 0px 3px ").concat(primitives.colors.primary.black)
            }
          })
        },
        action: {
          "& button svg": {
            height: primitives.spacings["5"],
            width: primitives.spacings["5"]
          }
        }
      }
    },
    MuiAlertTitle: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          color: "inherit"
        }, tokens.typography["headline-smaller"]), {}, {
          marginBottom: primitives.spacings["1"],
          lineHeight: primitives.lineHeights.compact
        })
      }
    }
  };
};

exports.makeAlertStyles = makeAlertStyles;